import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';

const propsSchema = [
  {
    key: 'scroll_effect',
    label: 'Menu Bar Animation',
    type: types.BOOLEAN
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'version',
    label: 'Version',
    type: types.ENUM,
    options: [1, 2]
  },
  {
    key: 'logo_link',
    label: 'Logo Link',
    type: types.TEXT
  },
  {
    key: 'first_set',
    label: 'First Set Items (v1)',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'subnav',
        label: 'Subnav',
        type: types.ARRAY,
        options: false,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          }
        ]
      }
    ]
  },
  {
    key: 'second_set',
    label: 'Second Set Items (v1)',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabel',
        label: 'Logged In Label',
        type: types.TEXT,
      },
      {
        key: 'subnav',
        label: 'Subnav',
        type: types.ARRAY,
        options: false,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'loggedInLabel',
            label: 'Logged In Label',
            type: types.TEXT,
          },
        ]
      }
    ]
  },
  {
    key: 'hero_button',
    label: 'Hero Button (v1)',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabel',
        label: 'Logged In Label',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'drawerLinks',
    label: 'Drawer Links (v2)',
    type: types.ARRAY,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabel',
        label: 'Logged In Label',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabelUrl',
        label: 'Logged In Label URL',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'logoType',
    label: 'Logo Type (v2)',
    type: types.ENUM,
    options: ['DYNAMIC', 'FULL', 'SIMPLE', 'FX SIMPLE', 'FX SIMPLE V2']
  },
  {
    key: 'transparent',
    label: 'Transparent (v2)',
    type: types.BOOLEAN,
  },
  {
    key: 'float',
    label: 'Float (v2), allow menu to float on top all the time',
    type: types.BOOLEAN,
  },
  {
    key: 'spacer',
    label: 'Space holder for menu height (v2)',
    type: types.BOOLEAN,
  },
  {
    key: 'background',
    label: 'Background, Linear Gradient (v2)',
    type: types.TEXT,
  },
];

const defaultProps = {
  scroll_effect: false,
  color_theme: 'LIGHT',
  logo_link: '/',
  first_set: [
    {
      label: 'FF 91',
      url: '/ff-91',
      subnav: [
        {
          url: '/ff-91#design',
          label: 'Design'
        },
        {
          url: '/ff-91#performance',
          label: 'Performance'
        },
        {
          url: '/ff-91#technology',
          label: 'Technology'
        },
        {
          url: '/ff-91#interior',
          label: 'Interior'
        }
      ]
    },
    {
      label: 'DESIGN YOURS',
      url: '/futuresight'
    },
    {
      label: 'APP',
      url: '/mobile-app'
    },
    {
      label: 'INVESTORS',
      url: 'https://investors.ff.com/'
    },
  ],
  second_set: [
    {
      label: 'SIGN IN',
      url: '/account',
      loggedInLabel: 'My FF'
    }
  ],
  hero_button: {
    label: 'PREORDER YOURS',
    url: '/preorder',
  },
  drawerLinks: [
    {
      label: 'Home',
      url: '/',
    },
    {
      label: 'Sign In',
      url: '/us/account/login',
      loggedInLabel: 'My FF',
      loggedInLabelUrl: '/us/MyFF',
    },
    {
      label: 'FF 91',
      url: '/us/ff-91',
    },
    {
      label: 'App',
      url: '/us/mobile-app',
    },
    {
      label: 'Investors',
      url: 'https://investors.ff.com/'
    },
    {
      label: 'Press Room',
      url: '/us/press-room'
    },
    {
      label: 'Contact Us',
      url: '/us/contact-us'
    },
  ],
  logoType: 'DYNAMIC'
};

export default {
  title: 'Menu Bar',
  id: 'MenuBar',
  propsSchema,
  defaultProps
};
